import { get } from "lodash";
import { FaSuitcaseRolling, FaCalendarCheck, FaBug } from "react-icons/fa";

import { StatsContainerWrapper } from "@/components/wrappers";

import { StatItem } from ".";

interface StatsContainerProps {
  defaultStats: {
    pending: number;
    interview: number;
    declined: number;
  };
}

const StatsContainer = ({ defaultStats }: StatsContainerProps) => {
  const stats = [
    {
      title: "pending applications",
      count: get(defaultStats, "pending", 0),
      icon: <FaSuitcaseRolling />,
      color: "#f59e0b",
      bgColor: "#fef3c7",
    },
    {
      title: "interviews scheduled",
      count: get(defaultStats, "interview", 0),
      icon: <FaCalendarCheck />,
      color: "#647acb",
      bgColor: "#e0e8f9",
    },
    {
      title: "jobs declined",
      count: get(defaultStats, "declined", 0),
      icon: <FaBug />,
      color: "#d66a6a",
      bgColor: "#ffeeee",
    },
  ];

  return (
    <StatsContainerWrapper>
      {stats.map(item => {
        return <StatItem key={item.title} {...item} />;
      })}
    </StatsContainerWrapper>
  );
};

export default StatsContainer;
